var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13.3968C5.7276 13.1727 6.70825 13 8 13C9.69345 13 11.0967 13.5615 12.3157 14.0492L12.3714 14.0715C13.6395 14.5788 14.7193 15 16 15C17.3873 15 18.2595 14.7692 18.7536 14.5715C18.8488 14.5335 18.9306 14.4964 19 14.4619V4.6032C18.2724 4.82731 17.2918 5 16 5C14.3066 5 12.9033 4.43852 11.6843 3.95077L11.6286 3.92848C10.3605 3.42124 9.28069 3 8 3C6.61272 3 5.74051 3.23083 5.24639 3.42848C5.15123 3.46654 5.06941 3.50364 5 3.53805V13V13.3968ZM5 14.4519V22H4V15V13V3C4 3 5 2 8 2C9.5 2 10.75 2.5 12 3C13.25 3.5 14.5 4 16 4C17.4037 4 18.3696 3.78106 19 3.54807C19.7169 3.28312 20 3 20 3V15C20 15 19 16 16 16C14.5 16 13.25 15.5 12 15C10.75 14.5 9.5 14 8 14C6.59627 14 5.63041 14.2189 5 14.4519Z",
    fill: "#161414"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flag.c67eb9162ebdd712658cfcad65f5e120.svg";